import { BigNumberish } from '@ethersproject/bignumber';

export type ReferrerOptions = {
  [chainId in SupportedChainId]?: {
    referrerAddress: string;
    fee: number;
  };
};

export type DefaultTokenOptions = {
  [chainId in SupportedChainId]?: string | 'NATIVE';
};

export type defaultTypedValueOptions = {
  [chainId in SupportedChainId]?: BigNumberish;
};

export type DefaultRpcJsonEndpoint = {
  [chainId in SupportedChainId]: string;
};

export type NetworkConfig = {
  chainName: string;
  chainIdHex: string;
  nativeCurrency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  blockExplorerUrls: string[];
  explorerName: string;
  helperContract: string;
  api: any;
  minGasLimit: string;
  supportedProtocols: string[];
};

export type NetworkListBtnType = {
  label: string | number;
  name: string;
  logo: () => void;
};

export type ConnectionMethod = {
  name: string;
  connector: any;
  logo: () => void;
};

export enum SupportedChainId {
  MAINNET = 1,
  ARBITRUM_ONE = 42161,
  // OPTIMISM = 10,
  POLYGON = 137,
  BINANCE = 56,
  AVALANCHE = 43114,
  FANTOM = 250,
  // GNOSIS = 100,
  // KLAYTN = 8217,
  // AURORA = 1313161554,
}

export enum SupportedChainIdInHex {
  MAINNET = '0x1',
  ARBITRUM_ONE = '0xA4B1',
  // OPTIMISM = '0xA',
  POLYGON = '0x89',
  BINANCE = '0x38',
  AVALANCHE = '0xA86A',
  FANTOM = '0xFA',
  // GNOSIS = '0x64',
  // KLAYTN = '0x2019',
  // AURORA = '0x4E454152',
}

export enum Field {
  INPUT = 'INPUT',
  OUTPUT = 'OUTPUT',
}

export enum ApproveStatus {
  UNKNOWN = 'UNKNOWN',
  APPROVAL_NEEDED = 'APPROVAL_NEEDED',
  PENDING = 'PENDING',
  NO_APPROVAL_NEEDED = 'NO_APPROVAL_NEEDED',
}

export enum SupportedGasOptions {
  Instant,
  High,
  Medium,
  Low,
}

export enum SupportedWallets {
  Metamask = 'Metamask',
  WalletConnect = 'WalletConnect',
}
